/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  UpdateSampleFulfillmentMutationRequest,
  UpdateSampleFulfillmentMutationResponse,
  UpdateSampleFulfillmentPathParams,
  UpdateSampleFulfillment400,
  UpdateSampleFulfillment403,
  UpdateSampleFulfillment404,
} from '../types/UpdateSampleFulfillment'

function getUpdateSampleFulfillmentUrl({
  id,
}: {
  id: UpdateSampleFulfillmentPathParams['id']
}) {
  const res = {
    method: 'PATCH',
    url: `/api/v1/samples/sample-requests/${id}/fulfillment/` as const,
  }
  return res
}

/**
 * @description Update fulfillment fields (status/tracking) on a sample request.
 * Returns:
 * 200: Fulfillment updated successfully
 * 400: Validation error
 * 403: Not authorized (broker/limited user)
 * 404: Sample request not found
 * 500: Unexpected server error
 * @summary Update a sample request's fulfillment status and tracking info
 * {@link /api/v1/samples/sample-requests/:id/fulfillment/}
 */
export async function updateSampleFulfillment(
  { id }: { id: UpdateSampleFulfillmentPathParams['id'] },
  data?: UpdateSampleFulfillmentMutationRequest,
  config: Partial<RequestConfig<UpdateSampleFulfillmentMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateSampleFulfillmentMutationResponse,
    ResponseErrorConfig<
      | UpdateSampleFulfillment400
      | UpdateSampleFulfillment403
      | UpdateSampleFulfillment404
    >,
    UpdateSampleFulfillmentMutationRequest
  >({
    method: 'PATCH',
    url: getUpdateSampleFulfillmentUrl({ id }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
